<template>
  <BreadCrumb PageTitle=" Liste des marchés" />
    <ListeMarche />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeMarche from "@/components/Marche/ListeMarche.vue";

  
    export default defineComponent({
      name: "ListeMarchePage",
      components: {
        ListeMarche,
      },
    });
  </script>